import Highlight from '@tiptap/extension-highlight'

/**
 * Enhanced Highlight extension with custom color support
 * Allows background colors to be set on text via the highlight extension
 */
export const EnhancedHighlight = Highlight.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      color: {
        default: null,
        parseHTML: element => {
          const style = element.getAttribute('style')
          if (style) {
            const match = style.match(/background-color:\s*([^;]+)/)
            if (match) return match[1].trim()
          }
          return element.getAttribute('data-color') || null
        },
        renderHTML: attributes => {
          if (!attributes.color) return {}
          return {
            'data-color': attributes.color,
            style: `background-color: ${attributes.color}`,
          }
        },
      },
    }
  },
  parseHTML() {
    return [
      {
        tag: 'mark',
        getAttrs: element => {
          const color = element.getAttribute('data-color')
          return color ? { color } : false
        },
      },
      {
        tag: 'span',
        getAttrs: element => {
          const style = element.getAttribute('style')
          if (style?.includes('background-color')) {
            const match = style.match(/background-color:\s*([^;]+)/)
            return match ? { color: match[1].trim() } : false
          }
          return false
        },
      },
    ]
  },
  renderHTML({ HTMLAttributes }) {
    const backgroundColor = HTMLAttributes['data-color']
    if (!backgroundColor) return ['span', HTMLAttributes, 0]
    return [
      'span',
      {
        ...HTMLAttributes,
        'data-color': backgroundColor,
        style: `background-color: ${backgroundColor}`,
      },
      0,
    ]
  },
})
